import { AxiosError } from 'axios';
import { getUserDetails } from 'services/userDetails/userDetails';

export const handleUserDetailsRequest = async () => {
  try {
    const data = await getUserDetails();
    return { data, status: 200 };
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      return {
        status: e.response?.status || 500,
        data: null,
      };
    }
    return {
      status: 500,
      data: null,
    };
  }
};
